import { HiringRequest, VendorData } from '@interfaces/open-positions.model';

export function mapHiringRequest(hiringRequest: HiringRequest) {
  const panels = hiringRequest.hiringRequestDto?.hiringPanels ?? [];
  const panelName = (panelNumber: number): string | null =>
    panels.find((panel) => Number(panel.panelNumber) === panelNumber)
      ?.employeeName ?? null;

  return {
    hiringRequestId: hiringRequest.hiringRequestDto?.hiringRequestId ?? null,
    numberOfPositions: hiringRequest.hiringRequestDto?.numberOfPositions ?? 0,
    yearsOfExperience: hiringRequest.hiringRequestDto?.yearsOfExperience ?? 0,
    yearsOfRelevantExperience:
      hiringRequest.hiringRequestDto?.yearsOfRelevantExperience ?? 0,
    desiredStartDate: hiringRequest.hiringRequestDto?.desiredStartDate ?? '',
    createdDate: hiringRequest.hiringRequestDto?.createdDate ?? '',
    jobDescription: hiringRequest.hiringRequestDto?.jobDescription ?? '',
    jobDescriptionPath:
      hiringRequest.hiringRequestDto?.jobDescriptionPath ?? '',
    additionalComments: hiringRequest.hiringRequestDto?.additionalComments ?? '',
    location: hiringRequest.hiringRequestDto?.location ?? '',
    employeeId: hiringRequest.hiringRequestDto?.employeeId ?? null,
    isPriority: hiringRequest.hiringRequestDto?.isPriority ?? '',
    status: hiringRequest.hiringRequestDto?.status ?? '',
    vendorName: Array.isArray(hiringRequest.hiringVendorDtoList)
      ? hiringRequest.hiringVendorDtoList?.map(
          (vendor) => vendor.vendorName, 
      )
      : [],
    jobTitle: hiringRequest.hiringRequestDto?.jobTitle ?? '',
    lobName: hiringRequest.hiringRequestDto?.lobName ?? '',
    noOfCandidates: hiringRequest.hiringRequestDto?.noOfCandidates ?? 0,
    dntLeaderName: hiringRequest.hiringRequestDto?.dntLeaderName ?? '',
    ageOld: hiringRequest.ageOld,
    projectName: hiringRequest.hiringRequestDto?.projectName ?? '',
    hiringManagerName: hiringRequest.hiringRequestDto?.hiringManagerName ?? '',
    panel1: panelName(1),
    panel2: panelName(2),
    panel3: panelName(3),
    skillName: Array.isArray(hiringRequest.skillName)
      ? hiringRequest.skillName
      : typeof hiringRequest.skillName === 'string' && hiringRequest.skillName
        ? [hiringRequest.skillName]
        : Array.isArray(hiringRequest.hiringRequestDto?.skillName)
          ? hiringRequest.hiringRequestDto.skillName
          : typeof hiringRequest.hiringRequestDto?.skillName === 'string' &&
              hiringRequest.hiringRequestDto.skillName
            ? [hiringRequest.hiringRequestDto.skillName]
            : [],
  };
}
